import { ROLES } from './roles'
import { FACM_STATUS } from './facmStatus'

export const roleToStatusMap = {
  [ROLES.MOUNTAIN_OFFICER]: FACM_STATUS.WAITING_MOUNTAIN_OFFICER,
  [ROLES.UNIT_COMMANDER]: FACM_STATUS.WAITING_UNIT_COMMANDER,
  [ROLES.CORPS_CHIEF]: FACM_STATUS.WAITING_CORPS_CHIEF,
}
